import Moment from 'moment';
import type { PresetOption } from './types';

export const usePresetOptions = () => {
  return [
    {
      label: '7 Days',
      value: {
        startDate: Moment().subtract(7, 'days').startOf('day').toDate(),
        endDate: Moment().toDate(),
      },
    },
    {
      label: '1 Month',
      value: {
        startDate: Moment().subtract(1, 'months').startOf('day').toDate(),
        endDate: Moment().toDate(),
      },
    },
    {
      label: '3 Months',
      value: {
        startDate: Moment().subtract(3, 'months').startOf('day').toDate(),
        endDate: Moment().toDate(),
      },
    },
    {
      label: '6 Months',
      value: {
        startDate: Moment().subtract(6, 'months').startOf('day').toDate(),
        endDate: Moment().toDate(),
      },
    },
    {
      label: '1 Year',
      value: {
        startDate: Moment().subtract(1, 'years').startOf('day').toDate(),
        endDate: Moment().toDate(),
      },
    },
    {
      label: '2 Years',
      value: {
        startDate: Moment().subtract(2, 'years').startOf('day').toDate(),
        endDate: Moment().toDate(),
      },
    },
    {
      label: '3 Years',
      value: {
        startDate: Moment().subtract(3, 'years').startOf('day').toDate(),
        endDate: Moment().toDate(),
      },
    },
  ] satisfies PresetOption[];
};
